import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const NotificationActions = createActionGroup({
  source: "Notification",
  events: {
    "Snackbar Open": props<{
      message: string;
      action?: string;      // button label, e.g. "OK"
      durationMs?: number;  // defaulted in effect
      panelClass?: string | string[]; // optional styling hook
    }>(),
    "Snackbar Close": emptyProps(),
  },
});
